import { Column } from "../decorators/column.decorator";
import { Model } from "../decorators/model.decorator";
import { BaseModel } from "./base.model";

@Model('oauth', ['oauthRequired'])
export class OAuth extends BaseModel {
  @Column()
  mandator: string | undefined;
  @Column()
  oauthUrl: string | undefined;
}
